import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from './HomePageBanner/hooks/useMediaQuery';
import styles from './MoreLess.module.scss';
import { MORE_LESS_CONTENT } from '../content/moreLessContent';

const REPEAT_TEXT_HORIZONTAL = 6;
const REPEAT_TEXT_VERTICAL = 8;

const BoltSvg = () => (
  <svg
    className={styles.bolt}
    width="35"
    height="60"
    viewBox="0 0 35 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6392_68036)">
      <path
        opacity="0.3"
        d="M19.4493 26.5204L28.8047 27.7002L8.17599 56.1518L16.0463 33.6912L5.59661 33.0626L27.4513 4.33625L19.4493 26.5204Z"
        fill="#FB04A8"
      />
    </g>
    <defs>
      <clipPath id="clip0_6392_68036">
        <rect width="21.0294" height="55" fill="white" transform="translate(14.2422 0.796875) rotate(15)" />
      </clipPath>
    </defs>
  </svg>
);

const MoreLessText = ({ textContent }: { textContent: typeof MORE_LESS_CONTENT }) => (
  <>
    {textContent.map(([textMore, textLess], index) => (
      <div className={styles.textLine} key={index}>
        {Array(REPEAT_TEXT_HORIZONTAL)
          .fill('')
          .map((_, lineIndex) => (
            <span key={`line-${lineIndex}`}>
              <BoltSvg />
              <span className={styles.textMore}>{textMore}</span>
              <span className={styles.textLess}>{textLess}</span>
            </span>
          ))}
      </div>
    ))}
  </>
);

/**
 * MoreLessComponent
 * We have a background with text set as a background. A transparent window that slides over the text
 * and a really large white blocks above and below he window
 * We keep track of whether the window is ont he page to set the visibiility of the white blocks
 * NOTE: We must ensure that the REALLY LARGE white blocks are larger than the entire document
 */

export const MoreLess = () => {
  const { isMobile } = useMediaQuery();
  const [onScreen, setOnScreen] = useState(false);
  const visibleHeightPx = isMobile ? 150 : 290;
  const observerRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (observerRef.current) {
      setOnScreen(true);
    }
  };

  useEffect(() => {
    // Initialize the Intersection Observer
    const options: IntersectionObserverInit = {
      root: null,
      rootMargin: '100px',
      threshold: 0,
    };

    if (observerRef.current) {
      const observer = new IntersectionObserver(entries => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          window.addEventListener('scroll', handleScroll);
        } else {
          // When the element exits the screen
          setOnScreen(false);
        }
      }, options);

      observer.observe(observerRef.current);

      return () => {
        observer.disconnect();
        window.removeEventListener('scroll', handleScroll);
      };
    }
  });
  return (
    <div
      aria-description={MORE_LESS_CONTENT.map(line => line.flat().join(','))
        .flat()
        .join('. ')}
    >
      {/* Text Background */}
      {onScreen && (
        <div className={styles.background}>
          {
            /* TODO: Optimise the component and only render enough backgrounds for the viewport height */
            Array(REPEAT_TEXT_VERTICAL)
              .fill('')
              .map((_, index) => (
                <MoreLessText textContent={MORE_LESS_CONTENT} key={index} />
              ))
          }
        </div>
      )}
      {/* Left Scrim */}
      {!isMobile && onScreen && <div className={styles.fadeLeft} />}
      {/* Whitespace above window */}
      <div
        style={{
          width: '100%',
          height: '110vh',
          backgroundColor: 'white',
          marginBottom: '-110vh',
          zIndex: -99,
          position: 'relative',
          top: '-110vh',
        }}
      />
      {/* Sliding Window */}
      <div
        ref={observerRef}
        style={{
          height: visibleHeightPx,
          width: '100%',
          opacity: 0,
        }}
      />
      {/* Whitespace below window */}
      <div
        style={{
          width: '100%',
          height: '110vh',
          backgroundColor: 'white',
          marginBottom: '-110vh',
          zIndex: -99,
          position: 'relative',
        }}
      />
      {/* Right Scrim */}
      {!isMobile && onScreen && <div className={styles.fadeRight} />}
    </div>
  );
};
